import React from 'react'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Head from 'next/head';
function ShopByColor() {
  return (
    <>
    <Head>
        <title>Shop Tiles By Color | Orientbell Tiles</title>
	
<meta name="title" content="Shop Tiles By Color | Orientbell Tiles"/>
<meta name="description" content="Orientbell Tiles offers a vast range of colorful tiles for walls and floors. Discover a variety of shades, materials, shapes, and sizes to suit every style. Shop now!"/>
        </Head>
    
    <div className='ShopByColor-section'>
    <div class='container'>
        <Breadcrumb>
      <Breadcrumb.Item href="https://www.orientbell.com">Home</Breadcrumb.Item>
      <Breadcrumb.Item href="#">Color</Breadcrumb.Item>
     
     
    </Breadcrumb>
        {/* <div className='ShopByColor-intro-section'> */}
            {/* <div className='container'> */}
                {/* <div className='ShopByColor-intro-row'> */}
                    {/* <div className='ShopByColor-intro-left'>
                        <img src="shop-banner.jpg" alt="image" />
                    </div> */}
                    {/* <div className='ShopByColor-intro-right'>
                        <h2>Shop Tiles By Color</h2>
                        <p>Colors are a powerful tool for creating just the right mood. Bring your design ideas to life with our range of colors from aquatic greens, teals and blues, to classic whites and creams. Create a calm ambiance with subtle, muted shades of color like soft greens, pinks, and earthy tones.</p>
                        <a href="#" className='default-btn shop-all-btn'>Shop all Tiles</a>
                    </div> */}
                {/* </div> */}
            {/* </div> */}
        {/* </div> */}
        <div className='find-color-section'>
            <div className='container'>
                <div className='find-color-heading-row'>
                    <h2>Shop Tiles By Color</h2>
                    <p>

Tiles come in a variety of colours that play a key role in setting the perfect mood. Transform your space with our diverse palette, from soothing aquatic greens and blues to warm teaks. Embrace timeless elegance with classic whites and creams, or create a peaceful atmosphere with soft, muted hues like gentle greens, pinks, and earthy tones.</p>
                </div>
                <div className='find-color-row'>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/white-tiles">
                            <div className='find-color-img'>
                                <img src="shop-White.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>White Tiles</h4>
                            </div>
                        </a>
                    </div>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/yellow-tiles">
                            <div className='find-color-img'>
                                <img src="shop-Yellow.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Yellow Tiles</h4>
                            </div>
                        </a>
                    </div>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/black-tiles">
                            <div className='find-color-img'>
                                <img src="shop-Black.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Black Tiles</h4>
                            </div>
                        </a>
                    </div>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/blue-tiles">
                            <div className='find-color-img'>
                                <img src="shop-Blue.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Blue Tiles</h4>
                            </div>
                        </a>
                    </div>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/brown-tiles">
                            <div className='find-color-img'>
                                <img src="shop-Brown.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Brown Tiles</h4>
                            </div>
                        </a>
                    </div>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/ivory-tiles">
                            <div className='find-color-img'>
                                <img src="shop-Cream.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Ivory Tiles</h4>
                            </div>
                        </a>
                    </div>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/green-tiles">
                            <div className='find-color-img'>
                                <img src="Shop-Green.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Green Tiles</h4>
                            </div>
                        </a>
                    </div>
                    {/* <div className='find-color-col'>
                        <a href="#">
                            <div className='find-color-img'>
                                <img src="Grey-White.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Grey & White Tiles</h4>
                            </div>
                        </a>
                    </div> */}
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/grey-tiles">
                            <div className='find-color-img'>
                                <img src="shop-Grey.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Grey Tiles</h4>
                            </div>
                        </a>
                    </div>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/multi-colour-tiles">
                            <div className='find-color-img'>
                                <img src="Shop-Multi.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Multi Color Tiles</h4>
                            </div>
                        </a>
                    </div>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/pink-tiles">
                            <div className='find-color-img'>
                                <img src="shop-Pink.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Pink Tiles</h4>
                            </div>
                        </a>
                    </div>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/red-tiles">
                            <div className='find-color-img'>
                                <img src="shop-Red.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Red Tiles</h4>
                            </div>
                        </a>
                    </div>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/beige-tiles">
                            <div className='find-color-img'>
                                <img src="BEIGE.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Beige Tiles</h4>
                            </div>
                        </a>
                    </div>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/black-and-white-tiles">
                            <div className='find-color-img'>
                                <img src="BLACK & WHITE.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Black & White Tiles</h4>
                            </div>
                        </a>
                    </div>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/light-tiles">
                            <div className='find-color-img'>
                                <img src="LIGHT.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Light Tiles</h4>
                            </div>
                        </a>
                    </div>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/cream-tiles">
                            <div className='find-color-img'>
                                <img src="CREAM.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Cream Tiles</h4>
                            </div>
                        </a>
                    </div>
                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/dark-tiles">
                            <div className='find-color-img'>
                                <img src="DARK.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Dark Tiles</h4>
                            </div>
                        </a>
                    </div>

                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/purple-tiles">
                            <div className='find-color-img'>
                                <img src="PURPLE.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Purple Tiles</h4>
                            </div>
                        </a>
                    </div>

                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/sandune-tiles">
                            <div className='find-color-img'>
                                <img src="SANDUNE.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Sandune Tiles</h4>
                            </div>
                        </a>
                    </div>

                    <div className='find-color-col'>
                        <a href="https://www.orientbell.com/tiles/terracotta-tiles">
                            <div className='find-color-img'>
                                <img src="TERRACOTT.jpg" alt="image" />
                            </div>
                            <div className='find-color-text'>
                                <h4>Terracotta Tiles</h4>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
</>
  )
}

export default ShopByColor